import {
  Icon,
  LightEntity,
  LogoTypes,
  SvgIconNames,
} from '@toggle/design-system';
import React, { useMemo } from 'react';

import * as Shared from '../../AssetLogo.styles';
import * as S from './LogoPlaceholder.styles';

const getLogo = ({
  entity,
  type,
  subClassIcon,
  iconName,
}: {
  entity: LightEntity;
  type?: string;
  subClassIcon?: SvgIconNames;
  iconName: SvgIconNames;
}) => {
  switch (true) {
    case type === LogoTypes.StockInitial:
      return (
        <S.LogoPlaceholderStyled data-testid="logo">
          {entity.name_short[0]}
        </S.LogoPlaceholderStyled>
      );
    case type === LogoTypes.EquitySector:
      return (
        <S.IconWrap>
          <Icon size={22} iconName={iconName} />
        </S.IconWrap>
      );
    case type === LogoTypes.FinancialInstrument:
      return (
        <S.IconWrap>
          <Icon size={22} iconName="BadgePercentage" />
        </S.IconWrap>
      );
    case type === LogoTypes.Crypto:
      return (
        <S.CryptoImage
          src="/app/static/images/icons/generic-cryptocurrency.svg"
          alt="crypto-icon"
          data-testid="crypto-icon"
        />
      );
    case type === LogoTypes.FxCurrency:
    case type === LogoTypes.Default:
      return (
        <S.IconWrap>
          <Icon size={22} iconName="Coin" />
        </S.IconWrap>
      );
    case !!subClassIcon:
      return (
        <S.IconWrap>
          <Icon size={22} iconName={subClassIcon} />
        </S.IconWrap>
      );
    default:
      return (
        <S.IconWrap>
          <Icon size={22} iconName={'ChartLine'} />
        </S.IconWrap>
      );
  }
};

interface LogoPlaceholderProps {
  entity: LightEntity;
  className?: string;
  size: number;
  type?: string;
  subClassIcon?: SvgIconNames;
  iconName: SvgIconNames;
}

export const LogoPlaceholder = ({
  entity,
  type,
  className,
  size,
  subClassIcon,
  iconName,
}: LogoPlaceholderProps) => {
  const logoMemo = useMemo(() => {
    return getLogo({ entity, type, subClassIcon, iconName });
  }, [entity, type, subClassIcon, iconName]);
  return (
    <Shared.LogoWrapper
      $size={size}
      className={className}
      data-testid="logo-placeholder"
    >
      {logoMemo}
    </Shared.LogoWrapper>
  );
};
